/**
 * Navigation — Mobile menu toggle + keyboard-accessible dropdowns
 */

export function initNavigation() {
	const toggle = document.querySelector( '.menu-toggle' );
	const nav    = document.querySelector( '.main-navigation' );

	if ( ! toggle || ! nav ) return;

	// Mobile menu open/close.
	toggle.addEventListener( 'click', () => {
		const isOpen = nav.classList.toggle( 'is-open' );
		toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
	} );

	// Sub-menu toggles (mobile).
	const subToggles = nav.querySelectorAll( '.sub-menu-toggle' );
	subToggles.forEach( btn => {
		btn.addEventListener( 'click', ( e ) => {
			const subMenu = e.currentTarget.closest( 'li' )?.querySelector( '.sub-menu' );
			if ( ! subMenu ) return;

			const isExpanded = btn.getAttribute( 'aria-expanded' ) === 'true';
			btn.setAttribute( 'aria-expanded', ! isExpanded ? 'true' : 'false' );
			subMenu.classList.toggle( 'is-open', ! isExpanded );
		} );
	} );

	// Close nav when clicking outside.
	document.addEventListener( 'click', ( e ) => {
		if ( nav.classList.contains( 'is-open' ) && ! nav.contains( e.target ) && ! toggle.contains( e.target ) ) {
			nav.classList.remove( 'is-open' );
			toggle.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	// Keyboard navigation: close dropdown on Escape.
	nav.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' ) {
			const openMenus = nav.querySelectorAll( '.sub-menu.is-open' );
			openMenus.forEach( m => m.classList.remove( 'is-open' ) );
			subToggles.forEach( b => b.setAttribute( 'aria-expanded', 'false' ) );
		}
	} );
}
